export function isDOMRect(rect: DOMRect | ClientRect): rect is DOMRect {
  return (<any>rect).x !== undefined || (<any>rect).y !== undefined;
}
